import { defineComponent as p, openBlock as t, createElementBlock as a, mergeProps as u, unref as o, renderSlot as L, createElementVNode as e, createCommentVNode as V } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, A = { key: 1 }, f = { key: 2 }, h = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconArrowsVertical"
}, _ = /* @__PURE__ */ p({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = g(s);
    return (i, l) => (t(), a("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      L(i.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", m, l[0] || (l[0] = [
        e("path", { d: "M168.49,191.51a12,12,0,0,1,0,17l-32,32a12,12,0,0,1-17,0l-32-32a12,12,0,0,1,17-17L116,203V53L104.49,64.49a12,12,0,1,1-17-17l32-32a12,12,0,0,1,17,0l32,32a12,12,0,0,1-17,17L140,53V203l11.51-11.52A12,12,0,0,1,168.49,191.51Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", A, l[1] || (l[1] = [
        e("path", {
          d: "M160,56V200l-32,32L96,200V56l32-32Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M165.66,194.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,212.69V43.31L101.66,61.66A8,8,0,0,1,90.34,50.34l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,43.31V212.69l18.34-18.35A8,8,0,0,1,165.66,194.34Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", f, l[2] || (l[2] = [
        e("path", { d: "M167.39,196.94a8,8,0,0,1-1.73,8.72l-32,32a8,8,0,0,1-11.32,0l-32-32A8,8,0,0,1,96,192h24V64H96a8,8,0,0,1-5.66-13.66l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,160,64H136V192h24A8,8,0,0,1,167.39,196.94Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", h, l[3] || (l[3] = [
        e("path", { d: "M164.24,195.76a6,6,0,0,1,0,8.48l-32,32a6,6,0,0,1-8.48,0l-32-32a6,6,0,0,1,8.48-8.48L122,217.51v-179L100.24,60.24a6,6,0,0,1-8.48-8.48l32-32a6,6,0,0,1,8.48,0l32,32a6,6,0,1,1-8.48,8.48L134,38.49v179l21.76-21.75A6,6,0,0,1,164.24,195.76Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", k, l[4] || (l[4] = [
        e("path", { d: "M165.66,194.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,212.69V43.31L101.66,61.66A8,8,0,0,1,90.34,50.34l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,43.31V212.69l18.34-18.35A8,8,0,0,1,165.66,194.34Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", w, l[5] || (l[5] = [
        e("path", { d: "M162.83,197.17a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66,0l-32-32a4,4,0,0,1,5.66-5.66L124,222.34V33.66L98.83,58.83a4,4,0,0,1-5.66-5.66l32-32a4,4,0,0,1,5.66,0l32,32a4,4,0,0,1-5.66,5.66L132,33.66V222.34l25.17-25.17A4,4,0,0,1,162.83,197.17Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  _ as default
};
